<template>
  <div class="swipe">
    <swipe :autoplay="4000" indicator-color="white" class="swip-info">
      <swipe-item v-for="(item, idx) in bannerList" :key="idx">
        <img :src="item.image_url" @click="onSwipeClick(idx)">
      </swipe-item>
    </swipe>
  </div>
</template>

<script>
  import {Swipe, SwipeItem} from "vant"
  export default {
    name: "BannerList",
    components: {
      Swipe, SwipeItem,
    },
    props: {
      bannerList: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {}
    },
    methods: {
      onSwipeClick(idx) {
        let bannerInfo = this.bannerList[idx]
        if (bannerInfo.to) {
          this.$router.push(bannerInfo.to)
        } else if (bannerInfo.href) {
          window.location.replace(bannerInfo.href)
        }
      },
    }
  }

</script>

<style lang="scss" scoped>
  .swipe {
    overflow: hidden;
    background: #f2f2f2;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }


  .swipe-info {
  }
  .swipe img {
    width: 100%;
  }
</style>
